import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Row,
  Container,
  Col,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

import { P, Breadcrumbs, Btn } from "../../../../AbstractElements";
import {
  AsesorSelectorContext,
  ContactContext,
  ContactDataContext,
  EntitySelectorContext,
  PersonalDataContext,
  SocialDataContext,
} from "../../ContextProvider";
import { useNavigate, useParams } from "react-router";

import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";

import copyContactToClipboard from "../../Services/CopyContactToClipBoardService";

import ContactData from "./ContactData";
import HistorialData from "./Historical/HistorialData";
import NoteProvider from "../../../Notes/Context/NoteProvider";
import { deleteConfirmationModal } from "../../../../Shared/Components/DeleteConfrimationModal";
import EmptyState from "../../../../Shared/Components/EmptyState";

const Index = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  //context

  const {
    item,
    getItem,
    setItem,
    exportItemData,
    deleteItem,
    lastId,
    firstId,
    getLastContact,
    getFirstContact,
    getNextContact,
    getPreviousContact,
    nextId,
    previousId,
    index,
    totalRows,
    setIndex,
    getTotalContacts,
  } = useContext(ContactContext);

  const { getItem: getPersonalData, item: personalData } =
    useContext(PersonalDataContext);

  const { item: contactData, getItem: getContactData } =
    useContext(ContactDataContext);

  const { item: socialData, getItem: getSocialData } =
    useContext(SocialDataContext);

  const { getContactEntities, contactEntities } = useContext(
    EntitySelectorContext
  );

  const { getContactAsesors, contactAsesors: asesors } = useContext(
    AsesorSelectorContext
  );

  useEffect(() => {
    if (id) {
      getItem(id);
      getPersonalData(id);
      getContactData(id);
      getSocialData(id);
      getContactEntities(id);
      getContactAsesors(id);
    } else {
      setItem({});
    }
  }, [id]);

  const handleDelete = (row) => {
    deleteConfirmationModal(row.id, deleteItem);
  };
  const handleCopyClipboard = () => {
    copyContactToClipboard(
      item,
      personalData,
      contactData,
      socialData,
      contactEntities,
      asesors
    );
  };

  const handleExportExcel = async () => {
    exportItemData(
      item,
      personalData,
      contactData,
      socialData,
      contactEntities,
      asesors
    );
  };
  const onEditClick = async () => {
    setItem(item);
    navigate(`${process.env.PUBLIC_URL}/app/contacts/edit/${item.id}`);
  };

  const handleNext = () => {
    if (index < totalRows - 1) {
      navigate(`${process.env.PUBLIC_URL}/app/contacts/detail/${nextId}`);
      setIndex(index + 1);
    }
  };

  const handlePrev = () => {
    if (index > 0) {
      navigate(`${process.env.PUBLIC_URL}/app/contacts/detail/${previousId}`);
      setIndex(index - 1);
    }
  };

  const handleFirst = async () => {
    setIndex(0);
    navigate(`${process.env.PUBLIC_URL}/app/contacts/detail/${firstId}`);
  };

  const handleLast = async () => {
    setIndex(totalRows - 1);
    navigate(`${process.env.PUBLIC_URL}/app/contacts/detail/${lastId}`);
  };

  useEffect(() => {
    if (!firstId) {
      getFirstContact();
    }
    if (!lastId) {
      getLastContact();
    }
  }, []);

  useEffect(() => {
    if (item?.id) {
      getNextContact();
      getPreviousContact();
    }

    if (!totalRows) {
      getTotalContacts();
    }
  }, [item]);

  return (
    <Fragment>
      <Breadcrumbs
        title="Detalle del contacto"
        mainTitle="Detalle del contacto"
        parent="Contactos"
      />
      <Container fluid Breadcrumbsfluid={true} className="list-products">
        <Row className="mb-3 d-flex justify-content-between align-items-center">
          <Col md="4"></Col>
          <Col md="8" className="d-flex justify-content-between">
            <div className="d-flex gap-3">
              <Btn
                attrBtn={{
                  className: "btn-no-bg-color",
                  style: {
                    padding: "0.6rem 0.75rem",
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#196B28",
                  },
                  onClick: handleFirst,
                }}
              >
                <FaAngleDoubleLeft />
              </Btn>
              <Btn
                attrBtn={{
                  color: "outline-primary",
                  onClick: handlePrev,
                }}
                className="d-flex align-items-center"
              >
                <i className="icofont icofont-arrow-left fs-5 "></i> Anterior
              </Btn>
              <span className="fw-bold">
                {index + 1} de {totalRows}
              </span>
              <Btn
                attrBtn={{
                  color: "primary",
                  onClick: handleNext,
                  disabled: lastId == item?.id,
                }}
                className="d-flex align-items-center"
              >
                Siguiente{" "}
                <i className="icofont icofont-arrow-right fs-5 primary"></i>
              </Btn>
              <Btn
                attrBtn={{
                  className: "btn-no-bg-color",
                  style: {
                    padding: "0.6rem 0.75rem",
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#196B28",
                  },
                  onClick: handleLast,
                }}
              >
                <FaAngleDoubleRight />
              </Btn>
            </div>

            {item?.id && (
              <UncontrolledDropdown className="btn-group">
                <DropdownToggle
                  className="btn-acciones"
                  caret
                  style={{
                    position: "relative",
                  }}
                >
                  Acciones
                  <i
                    className="fa fa-ellipsis-h"
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                    }}
                  ></i>
                  <span style={{ color: "transparent" }}>▼</span>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={onEditClick}>Modificar</DropdownItem>
                  <DropdownItem onClick={handleDelete}>Eliminar</DropdownItem>
                  <DropdownItem onClick={handleCopyClipboard}>
                    Copiar al Clipboard
                  </DropdownItem>
                  <DropdownItem onClick={handleExportExcel}>
                    Exportar a Excel
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
          </Col>
        </Row>
        {item && item?.id ? (
          <Row className="list-persons">
            <Col xl="4" md="4">
              {/* componente que tiene la data del perfil */}
              <ContactData
                item={item}
                personalData={personalData}
                contactData={contactData}
                socialData={socialData}
                asesors={asesors}
                contactEntities={contactEntities}
              ></ContactData>
            </Col>
            <Col xl="8" md="8">
              {/* componente que tiene el historial del perfil */}
              <NoteProvider>
                <HistorialData contact_id={item?.id}></HistorialData>
              </NoteProvider>
            </Col>
          </Row>
        ) : (
          <EmptyState msg="Contacto no encontrado"></EmptyState>
        )}
      </Container>
    </Fragment>
  );
};

export default Index;
